import React, { useState, useEffect } from 'react';
import styles from '../tables.module.css';
import { PRISMAX_BACKEND_URL } from "../../../configs/config";

const UserStatsTableV2 = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchUserStats = async () => {
      try {
        const token = localStorage.getItem('prismax_admin_token');
        const response = await fetch(`${PRISMAX_BACKEND_URL}/api/user-stats-v2`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        
        if (!response.ok) {
          throw new Error('Failed to fetch user stats');
        }
        
        const responseData = await response.json();
        setData(responseData);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchUserStats();
  }, []);

  if (loading) {
    return <div className={styles.loading}>Loading user statistics...</div>;
  }

  if (error) {
    return <div className={styles.error}>Error: {error}</div>;
  }

  if (!data || !data.table_user_class || !data.table_teleop) {
    return <div className={styles.error}>No data available</div>;
  }

  const { table_user_class, table_teleop } = data;

  const formatConnectionType = (string) => {
    if (string.length === 0) {
      return "";
    }
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  return (
    <div className={styles.tableContainer}>
      {/* Table 1: User Class by Connection Type */}
      <h2 className={styles.tableTitle}>User Class Statistics</h2>
      <div className={styles.tableWrapper}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Category</th>
              {table_user_class.user_classes.map(userClass => (
                <th key={userClass}>{userClass}</th>
              ))}
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            {table_user_class.table_data.map(row => (
              <tr key={row.connection_type}>
                <td><strong>{formatConnectionType(row.connection_type)}</strong></td>
                {table_user_class.user_classes.map(userClass => (
                  <td key={userClass}>{row.values[userClass].toLocaleString()}</td>
                ))}
                <td><strong>{row.row_total.toLocaleString()}</strong></td>
              </tr>
            ))}
            <tr className={styles.totalRow}>
              <td><strong>Total</strong></td>
              {table_user_class.user_classes.map(userClass => (
                <td key={userClass}><strong>{table_user_class.column_totals[userClass].toLocaleString()}</strong></td>
              ))}
              <td><strong>{table_user_class.grand_total.toLocaleString()}</strong></td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* Table 2: Tele-Op Statistics by Connection Type */}
      <h2 className={styles.tableTitle} style={{marginTop: '40px'}}>User Tele-Op Statistics</h2>
      <div className={styles.tableWrapper}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Category</th>
              <th>Tele-Op Sessions</th>
              <th>Tele-Op Hours</th>
              <th>Tele-Op Users</th>
            </tr>
          </thead>
          <tbody>
            {table_teleop.table_data.map(row => (
              <tr key={row.connection_type}>
                <td><strong>{formatConnectionType(row.connection_type)}</strong></td>
                <td>{row.teleop_sessions.toLocaleString()}</td>
                <td>{row.teleop_hours.toLocaleString()}</td>
                <td>{row.teleop_users.toLocaleString()}</td>
              </tr>
            ))}
            <tr className={styles.totalRow}>
              <td><strong>Total</strong></td>
              <td><strong>{table_teleop.total_sessions.toLocaleString()}</strong></td>
              <td><strong>{table_teleop.total_hours.toLocaleString()}</strong></td>
              <td><strong>{table_teleop.total_users.toLocaleString()}</strong></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default UserStatsTableV2;